import { type CSSProperties } from "react";

interface WorkspaceHeaderProps {
  name: string;
  moduleCount: number;
  agentCount: number;
  entityCount: number;
  onNewAgent: () => void;
}

function PatternBlocks() {
  const size = 36;
  const cellSize = size / 3;
  const fills = [
    "var(--c-purple-600)", "var(--c-teal-400)", "var(--c-coral-400)",
    "var(--c-blue-400)", "var(--c-green-600)", "var(--c-amber-400)",
    "var(--c-pink-400)", "var(--c-red-400)", "var(--c-gray-400)",
  ];
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ borderRadius: 6, flexShrink: 0 }}>
      {fills.map((fill, i) => (
        <rect
          key={i}
          x={(i % 3) * cellSize}
          y={Math.floor(i / 3) * cellSize}
          width={cellSize}
          height={cellSize}
          fill={fill}
        />
      ))}
    </svg>
  );
}

export function WorkspaceHeader({ name, moduleCount, agentCount, entityCount, onNewAgent }: WorkspaceHeaderProps) {
  const root: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: 14,
    marginBottom: 28,
    fontFamily: "var(--font-sans)",
  };

  const stats: CSSProperties = {
    fontSize: 12,
    color: "var(--color-text-tertiary)",
    marginTop: 2,
  };

  return (
    <div style={root}>
      <PatternBlocks />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 15, fontWeight: 500, color: "var(--color-text-primary)" }}>{name}</div>
        <div style={stats}>
          {moduleCount} {moduleCount === 1 ? "module" : "modules"} · {agentCount} {agentCount === 1 ? "agent" : "agents"} · {entityCount} {entityCount === 1 ? "entity" : "entities"}
        </div>
      </div>
      <button
        data-variant="primary"
        onClick={onNewAgent}
        style={{
          fontSize: 13,
          padding: "8px 14px",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <i className="ti ti-plus" style={{ fontSize: 14 }} aria-hidden="true" />
        New agent
      </button>
    </div>
  );
}
